import type { SiteText } from "./types.js";

/** Русский текст сайта: для владельца салона или барбершопа в Белграде, который читает по-русски. Не перевод, а живой текст. */
export const ru: SiteText = {
  nav: { pricing: "Цены", terms: "Условия", refund: "Возврат", privacy: "Конфиденциальность", login: "Войти", home: "Главная" },
  hero: {
    title: "Онлайн-запись и ИИ-ассистент в Instagram",
    text: "Календарь для салонов и барбершопов, которые работают по записи. Ассистент отвечает клиентам в Instagram Direct и записывает их в ваш календарь, опираясь только на то, что вы сами указали: услуги, цены, график, правила.",
    cta: "Посмотреть цены",
    login: "Вход для салонов",
    note: "Без предоплат и без рассылок. Последнее слово всегда за мастером.",
  },
  demo: {
    chatTitle: "Instagram Direct",
    messages: [
      { from: "client", text: "Здравствуйте! Есть завтра время после 17:00 на fade?" },
      {
        from: "assistant",
        text: "Здравствуйте! Завтра свободно 17:30 у Марко и 18:00 у Николы. Fade длится 30 минут и стоит 1 500 RSD. Какое время вам удобнее?",
      },
      { from: "client", text: "17:30 к Марко." },
      { from: "assistant", text: "Fade у Марко завтра в 17:30, 1 500 RSD. Записываю?" },
      { from: "client", text: "Да." },
      { from: "assistant", text: "Готово: завтра в 17:30, fade у Марко. До встречи!" },
    ],
    bookingTitle: "Календарь",
    booking: { time: "17:30–18:00", client: "Luka", details: "Fade · Марко · записал ассистент", status: "подтверждена" },
  },
  how: {
    title: "Как это работает",
    steps: [
      {
        title: "Подключаете Instagram",
        text: "Профессиональный аккаунт салона подключается через окно входа Meta. Пароли и доступ к вашему телефону нам не нужны.",
      },
      {
        title: "Заполняете услуги и правила",
        text: "Услуги, цены, длительность, мастера, график и правила отмены можно загрузить из прайса (фото, PDF, Word, Excel), голосового или обычного текста. Вы всё проверяете до того, как ассистент начнёт отвечать.",
      },
      {
        title: "Ассистент отвечает и записывает",
        text: "Отвечает только по данным салона, предлагает свободное время и вносит запись в календарь. Если чего-то не знает, передаёт диалог мастеру.",
      },
    ],
  },
  features: {
    title: "Что вы получаете",
    items: [
      { title: "Календарь", text: "Услуги с ценой и длительностью, мастера, графики, выходные и запись вручную в два касания." },
      {
        title: "Ответы ассистента",
        text: "Цены, услуги, адрес, часы работы и правила: только из данных салона. Если ответа нет, ассистент напишет клиенту, что уточнит у мастера.",
      },
      {
        title: "Последнее слово за мастером",
        text: "Когда ассистент передаёт диалог, уведомление получают все мастера. Кто нажал «Взять диалог», тот и отвечает, а ассистент молчит.",
      },
      { title: "Страница записи", text: "Ссылка для шапки профиля в Instagram и QR-код: клиент записывается сам, без переписки." },
      { title: "Отчёт за месяц", text: "Одна строка в месяц: сколько записей сделал ассистент и на какую сумму." },
      { title: "Без предоплат", text: "Мы ничего не берём с ваших клиентов и не делаем рассылок." },
    ],
  },
  pricingTeaser: {
    title: "Одна цена, без комиссий",
    price: "€25",
    per: "в месяц",
    points: ["Первый месяц бесплатно, списание через 30 дней", "Диалогов сколько угодно (есть суточный лимит против спама)", "Отменить можно в любой момент"],
    cta: "Подробнее о ценах",
    setup: "Подключение бесплатно: около 15 минут по шагам.",
  },
  faq: {
    title: "Частые вопросы",
    items: [
      {
        q: "Клиенты знают, что им отвечает ИИ?",
        a: "Сам ассистент об этом не объявляет, но на прямой вопрос отвечает честно. В настройках можно сделать так, чтобы он сразу говорил, что он ИИ-ассистент.",
      },
      {
        q: "А если ассистент не знает ответа?",
        a: "Пишет клиенту, что уточнит у мастера, и передаёт диалог вам. Вы отвечаете один раз, и в следующий раз ассистент ответит сам.",
      },
      {
        q: "Можно ли ответить клиенту самому?",
        a: "Да, в любой момент. Пока отвечает мастер, ассистент молчит. А можно и вовсе поставить его на паузу.",
      },
      {
        q: "Что нужно для подключения?",
        a: "Профессиональный аккаунт салона в Instagram и бизнес-портфолио Meta. Подключение идёт через окно входа Meta, пароли вы нам не передаёте.",
      },
      {
        q: "Сколько времени занимает настройка?",
        a: "Около 15 минут по шагам: услуги, мастера, график, правила. Если что-то не получается, напишите нам, поможем.",
      },
      {
        q: "Вы что-то берёте с моих клиентов?",
        a: "Нет. Никаких предоплат, депозитов и рассылок. Вы платите только за подписку салона.",
      },
      {
        q: "Можно ли отменить подписку?",
        a: "Да, в любой момент на странице подписки. Доступ сохраняется до конца оплаченного периода.",
      },
    ],
  },
  pricing: {
    title: "Цены",
    subtitle: "Одна подписка на весь салон: календарь, ассистент, страница записи и отчёт за месяц.",
    plan: "Подписка",
    price: "€25",
    per: "в месяц",
    points: [
      "Без комиссий и без ограничения числа диалогов (есть суточный лимит против спама)",
      "Первый месяц бесплатно: карта привязывается сразу, первое списание через 30 дней",
      "Отмена в любой момент, без годового договора",
    ],
    setupTitle: "Подключение",
    self: { title: "Подключаетесь сами", price: "Бесплатно", text: "Пошаговая настройка, около 15 минут. Если что-то не получится, поможем." },
    vat: "Если с покупки положен налог, Paddle рассчитает его по стране покупателя и покажет итоговую сумму до оплаты.",
    mor: "Платежи принимает Paddle.com: по всем нашим заказам он выступает официальным продавцом (Merchant of Record).",
    start: "Начать",
  },
  footer: {
    rights: "Все права защищены.",
    tagline: "Календарь и ИИ-ассистент для салонов, которые работают по записи.",
    contact: "Контакты",
    language: "Язык",
    legal: "Документы",
  },
  draft: "Черновик: текст ещё не проверен юристом.",
  updated: "Обновлено",
};
